'use strict';

function VerifyEmail() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this._email_address = null;

  this.init = function () {
    this._email_address = this.presenter.models.account.unconfirmed_email ? this.presenter.models.account.unconfirmed_email : this.presenter.models.account.email_address;
    this.emailUpdateSection = $('#ChangeEmail__form_new_email');
    this.resendEmail = $('.js--resend-email-btn', this.node);
    $('#email').text(this._email_address);
    this.resendEmail.on('click', $.proxy(this._resendEmail, this));
  };

  this.initAllReady = function () {};

  this._resendEmail = function () {
    $('button[type=submit]', this.emailUpdateSection).trigger('click');
    this._toggleResend();
    this._onEmailSent();
  };

  this._toggleResend = function () {
    $('#cant-find').toggle();
    $('#email-resent').toggle();
  };

  this._onEmailSent = function () {
    setTimeout(this._toggleResend, 10000);
  };

  this.destroy = function () {
    this.resendEmail.off('click', $.proxy(this._resendEmail, this));
  };
}